// extracted by mini-css-extract-plugin
export var container = "pairedBlock-module--container--6ee53";
export var item = "pairedBlock-module--item--f536c";